var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ticker red",style:({
    position: 'absolute',
    top: 0,
    width: '2px',
    height: _vm.height,
    left: _vm.left,
  })})}
var staticRenderFns = []

export { render, staticRenderFns }